<script setup lang="ts">
import { type CardDescription, CardLabelColorMaps } from '@itinerary/types';

const { info } = defineProps<{
    info: CardDescription;
}>();
const color = computed(
    () =>
        info.color ||
        CardLabelColorMaps[info.backgroundColor!] ||
        'var(--gray-900)'
);
</script>

<template>
    <div
        class="package-info-description-container"
        :style="{ backgroundColor: info.backgroundColor, '--color': color }"
    >
        <div class="title-container">
            <mr-icon
                v-if="info.icon"
                class="icon"
                :icon="info.icon"
                :color
                size="x-small"
            />
            <div class="title">
                {{ info.title }}
            </div>
        </div>
        <p class="description">
            {{ info.description }}
        </p>
    </div>
</template>

<style lang="scss" scoped>
.package-info-description-container {
    display: flex;
    flex-direction: column;
    padding: 10px 8px;
    border-radius: 8px;
    margin-bottom: 8px;
}

.title-container {
    display: flex;
    align-items: center;
    margin-bottom: 4px;
    .icon {
        margin-left: 4px;
    }
    .title {
        @include tg-s($w7, var(--color));
    }
}

.description {
    @include tg-s($color: var(--color));
    margin: 0;
}
</style>
